@if (!showReviewStatus) {
<div class="provider-info-panel__grid">
  <div class="provider-info-panel__item business">
    <span class="provider-info-panel__section-title">Business Information</span>
    <div>
      <div class="provider-info-panel__label">
        <span>Business Address:</span>
      </div>
      <div class="provider-info-panel__value">
        <span [innerHTML]="getAddressWithLineBreaks(providerData.address) || '-'"></span>
      </div>
      <div class="provider-info-panel__label">
        <span>County: </span>
      </div>
      <div class="provider-info-panel__value">
        <span>
          {{ county !== '-' ? county : '-' }}
        </span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>Email Address:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ providerData.email || '-' }}</span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>{{ isTransportation ? 'Phone Number:' : 'Phone No:' }}</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ providerData.phone ? (providerData.phone | phone) : '-' }}</span>
      </div>
    </div>
    @if (isTransportation) {
    <div>
      <div class="provider-info-panel__label">
        <span>Phone Number Ext:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ getPhoneExtension(providerData.phone) }}</span>
      </div>
    </div>
    }
    <div>
      <div class="provider-info-panel__label">
        <span>Secondary Phone Number:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ secondaryBusinessPhone ? (secondaryBusinessPhone | phone) : '-' }}</span>
      </div>
    </div>
    @if (isTransportation) {
    <div>
      <div class="provider-info-panel__label">
        <span>Secondary Phone Number Ext:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ getPhoneExtension(providerData.secondaryPhone) }}</span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>Provider ID:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ providerData.recordNumber || '-' }}</span>
      </div>
    </div>
    }
  </div>
  @if (!isTransportation) {
  <div class="provider-info-panel__item personal">
    <span class="provider-info-panel__section-title">Personal Information</span>
    <div class="grid">
      @if (isProviderType(ProviderType.Tutor)) {
      <div class="col-6">
        <div>
          <div class="provider-info-panel__label">
            <span>Personal Address:</span>
          </div>
          <div class="provider-info-panel__value">
            <span [innerHTML]="getAddressWithLineBreaks(ownerDetails.personalAddress) || '-'">
            </span>
          </div>
          <div class="provider-info-panel__label">
            <span>County: </span>
          </div>
          <div class="provider-info-panel__value">
            <span>
              {{ personalCounty }}
            </span>
          </div>
        </div>
        <div>
          <div class="provider-info-panel__label">
            <span>Date of Birth:</span>
          </div>
          <div class="provider-info-panel__value">
            <span>{{ formatDate(ownerDetails.birthDate) || '-' }}</span>
          </div>
        </div>
        <div>
          <div class="provider-info-panel__label">
            <span>Last 4 of SSN:</span>
          </div>
          <div class="provider-info-panel__value">
            <span>{{ displayedSsnLast4 }}</span>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div>
          <div class="provider-info-panel__label">
            <span>School Name:</span>
          </div>
          <div class="provider-info-panel__value">
            <span>
              {{ ownerDetails.schoolName || '-' }}
            </span>
          </div>
        </div>
        <div>
          <div class="provider-info-panel__label">
            <span>Graduation Date:</span>
          </div>
          <div class="provider-info-panel__value">
            <span>
              {{ formatDate(ownerDetails.graduationDate) || '-' }}
            </span>
          </div>
        </div>
      </div>
      }
      @if (isProviderType(ProviderType.Therapy)) {
      <div class="col-6">
        <div>
          <div class="provider-info-panel__label">
            <span>Personal Address:</span>
          </div>
          <div class="provider-info-panel__value">
            <span [innerHTML]="getAddressWithLineBreaks(ownerDetails.personalAddress) || '-'">
            </span>
          </div>
          <div class="provider-info-panel__label">
            <span>County: </span>
          </div>
          <div class="provider-info-panel__value">
            <span>
              {{ personalCounty }}
            </span>
          </div>
        </div>
        <div>
          <div class="provider-info-panel__label">
            <span>Date of Birth:</span>
          </div>
          <div class="provider-info-panel__value">
            <span>{{formatDate(ownerDetails.birthDate) || '-'}}</span>
          </div>
        </div>
        <div>
          <div class="provider-info-panel__label">
            <span>Last 4 of SSN:</span>
          </div>
          <div class="provider-info-panel__value">
            <span>{{ displayedSsnLast4 }}</span>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div>
          <div class="provider-info-panel__label">
            <span>NPI-1:</span>
          </div>
          <div class="provider-info-panel__value" [ngClass]="{'disable-npi': employeeCount>=2}">
            <span>{{ (providerData.npiNumber ?? ownerDetails.npiNumber) || '-' }}</span>
          </div>
        </div>
        <div>
          <div class="provider-info-panel__label">
            <span>NPI-2:</span>
          </div>
          <div class="provider-info-panel__value" [ngClass]="{'disable-npi': employeeCount<2}">
            <span>{{ (providerData.npiNumber2 ?? ownerDetails.npiNumber2) || '-' }}</span>
          </div>
        </div>
        <div>
          <div class="provider-info-panel__label">
            <span>License No:</span>
          </div>
          <div class="provider-info-panel__value">
            <span>{{ (providerData.licenseNumber ?? ownerDetails.licenseNumber) || '-' }}</span>
          </div>
        </div>
        <div>
          <div class="provider-info-panel__label">
            <span>Issuing State:</span>
          </div>
          <div class="provider-info-panel__value">
            <span>{{ getSelectedIssuingState()?.name || '-' }}</span>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  <div class="provider-info-panel__grey-section">
    <div class="provider-info-panel__grey-item">
      <span class="provider-info-panel__sub-title">Provider ID</span>
      <span class="provider-info-panel__sub-title__label text-wrap">{{ providerData.recordNumber || '-'}}</span>
    </div>
  </div>
  <div class="provider-info-panel__grey-section">
    <div class="provider-info-panel__grey-item">
      <span class="provider-info-panel__sub-title">Business Name</span>
      <span class="provider-info-panel__sub-title__label text-wrap">{{ providerData.businessName || '-'}}</span>
    </div>
  </div>
  <div class="provider-info-panel__grey-section">
    <div class="provider-info-panel__grey-item">
      <span class="provider-info-panel__sub-title">Employees</span>
      <span class="provider-info-panel__sub-title__label text-wrap">{{ employeesSummaryLabel() }}</span>
    </div>
  </div>
  } @else {
  <div class="provider-info-panel__item provider-app-personal">
    <span class="provider-info-panel__section-title">Personal Information</span>
    <div>
      <div class="provider-info-panel__label">
        <span>Personal Address:</span>
      </div>
      <div class="provider-info-panel__value">
        <span [innerHTML]="getAddressWithLineBreaks(ownerDetails.personalAddress) || '-'"></span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>County:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ personalCounty }}</span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>Email Address:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ displayedEmail }}</span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>Phone Number:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ ownerDetails.phone ? (ownerDetails.phone | phone) : '-' }}</span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>Phone Number Ext:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ getPhoneExtension(ownerDetails.phone) }}</span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>Secondary Phone Number:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ ownerDetails.secondaryPhone ? (ownerDetails.secondaryPhone | phone) : '-' }}</span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>Secondary Phone Number Ext:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ getPhoneExtension(ownerDetails.secondaryPhone) }}</span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>Last 4 of SSN:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ displayedSsnLast4 }}</span>
      </div>
    </div>
  </div>
  <div class="provider-info-panel__item services">
    <span class="provider-info-panel__section-title">Services</span>
    <div>
      <div class="provider-info-panel__label">
        <span>Services:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>Transportation</span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>License Number:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ (providerData.licenseNumber ?? ownerDetails.licenseNumber) || '-' }}</span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>Issuing State:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ getSelectedIssuingState()?.name || '-' }}</span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>Number of Employees:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ employeeTotal }}</span>
      </div>
    </div>
  </div>
  }
</div>
} @else {
<div class="provider-info-panel__grid">
  <div class="provider-info-panel__item business">
    <span class="provider-info-panel__section-title">Business Information</span>
    <div>
      <div class="provider-info-panel__label">
        <span>Business Address:</span>
      </div>
      <div class="provider-info-panel__value">
        <span [innerHTML]="getAddressWithLineBreaks(providerData.address) || '-'"></span>
      </div>
      <div class="provider-info-panel__label">
        <span>County: </span>
      </div>
      <div class="provider-info-panel__value">
        <span>
          {{ county !== '-' ? county : '-' }}
        </span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>Email Address:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ providerData.email || '-' }}</span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>Phone Number:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ providerData.phone ? (providerData.phone | phone) : '-' }}</span>
      </div>
    </div>
    @if (isTransportation) {
    <div>
      <div class="provider-info-panel__label">
        <span>Phone Number Ext:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ getPhoneExtension(providerData.phone) }}</span>
      </div>
    </div>
    }
    <div>
      <div class="provider-info-panel__label">
        <span>Secondary Phone Number:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ providerData.secondaryPhone ? (providerData.secondaryPhone | phone) : '-' }}</span>
      </div>
    </div>
    @if (isTransportation) {
    <div>
      <div class="provider-info-panel__label">
        <span>Secondary Phone Number Ext:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ getPhoneExtension(providerData.secondaryPhone) }}</span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>Provider ID:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ providerData.recordNumber || '-' }}</span>
      </div>
    </div>
    }
  </div>

  <div class="provider-info-panel__item provider-app-personal">
    <span class="provider-info-panel__section-title">Personal Information</span>
    <div>
      <div class="provider-info-panel__label">
        <span>Personal Address:</span>
      </div>
      <div class="provider-info-panel__value">
        <span [innerHTML]="getAddressWithLineBreaks(ownerDetails.personalAddress) || '-'"></span>
      </div>
      <div class="provider-info-panel__label">
        <span>County: </span>
      </div>
      <div class="provider-info-panel__value">
        <span>
          {{ personalCounty }}
        </span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>Email Address:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ displayedEmail }}</span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>Phone Number:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ ownerDetails.phone ? (ownerDetails.phone | phone) : '-' }}</span>
      </div>
    </div>
    @if (isTransportation) {
    <div>
      <div class="provider-info-panel__label">
        <span>Phone Number Ext:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ getPhoneExtension(ownerDetails.phone) }}</span>
      </div>
    </div>
    }
    <div>
      <div class="provider-info-panel__label">
        <span>Secondary Phone Number:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ ownerDetails.secondaryPhone ? (ownerDetails.secondaryPhone | phone) : '-' }}</span>
      </div>
    </div>
    @if (isTransportation) {
    <div>
      <div class="provider-info-panel__label">
        <span>Secondary Phone Number Ext:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ getPhoneExtension(ownerDetails.secondaryPhone) }}</span>
      </div>
    </div>
    }
    @if (!isTransportation) {
    <div>
      <div class="provider-info-panel__label">
        <span>Date of Birth:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ formatDate(ownerDetails.birthDate) || '-' }}</span>
      </div>
    </div>
    }
    <div>
      <div class="provider-info-panel__label">
        <span>Last 4 of SSN:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ displayedSsnLast4 }}</span>
      </div>
    </div>
    @if (isProviderType(ProviderType.Tutor)) {
    <div>
      <div class="provider-info-panel__label">
        <span>School Name:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ ownerDetails.schoolName || '-' }}</span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>Graduation Date:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ formatDate(ownerDetails.graduationDate) || '-' }}</span>
      </div>
    </div>
    }
  </div>

  <div class="provider-info-panel__item services">
    <span class="provider-info-panel__section-title">Services</span>
    <div>
      <div class="provider-info-panel__label">
        <span>{{ isTransportation ? 'Services:' : 'Sub Service:' }}</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{
          isTransportation ? 'Transportation' : subServicesDisplay() || '-'
        }}</span>
      </div>
    </div>
    @if (isProviderType(ProviderType.Therapy)) {
    <div>
      <div class="provider-info-panel__label">
        <span>NPI 1 Number:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ providerData.npiNumber || '-' }}</span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>NPI 2 Number:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ providerData.npiNumber2 || '-' }}</span>
      </div>
    </div>
    }
    @if (!isProviderType(ProviderType.Tutor)) {
    <div>
      <div class="provider-info-panel__label">
        <span>License Number:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ providerData.licenseNumber || '-' }}</span>
      </div>
    </div>
    <div>
      <div class="provider-info-panel__label">
        <span>Issuing State:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ getSelectedIssuingState()?.name || '-' }}</span>
      </div>
    </div>
    }
    @if (isTransportation) {
    <div>
      <div class="provider-info-panel__label">
        <span>Number of Employees:</span>
      </div>
      <div class="provider-info-panel__value">
        <span>{{ employeeTotal }}</span>
      </div>
    </div>
    }
  </div>
  @if (!isTransportation) {
  <div class="provider-info-panel__grey-section">
    <div class="provider-info-panel__grey-item">
      <span class="provider-info-panel__sub-title">Business Name</span>
      <span class="provider-info-panel__sub-title__label text-wrap">{{ providerData.businessName || '-'}}</span>
    </div>
  </div>
  <div class="provider-info-panel__grey-section">
    <div class="provider-info-panel__grey-item">
      <span class="provider-info-panel__sub-title">Provider Name</span>
      <span class="provider-info-panel__sub-title__label text-wrap">{{ ownerDisplayName() || '-'}}</span>
    </div>
  </div>
  <div class="provider-info-panel__grey-section">
    <div class="provider-info-panel__grey-item">
      <span class="provider-info-panel__sub-title">Service Type</span>
      <span class="provider-info-panel__sub-title__label text-wrap">{{ serviceTypeLabel() || '-'}}</span>
    </div>
  </div>
  }
</div>
}